<template>
  <div class="pdt-20px">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionCommande.renouvellement.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-3">
            <b-field :label="$t('editionCommande.renouvellement.labelRenouvellementDetail')"
            custom-class="has-text-weight-light is-italic">
              <div class="has-text-weight-bold has-text-link">
                <p v-if="devisCommande.renouvelable">
                  {{ $t('editionCommande.renouvellement.renouvelable') }}
                </p>
                <p v-else>{{ $t('editionCommande.renouvellement.nonRenouvelable') }}</p>
              </div>
            </b-field>
          </div>
          <div class="column is-3" v-if="devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.labelReconductionDetail')"
                     custom-class="has-text-weight-light is-italic">
              <div class="has-text-weight-bold has-text-link">
                <p v-if="devisCommande.reconductible">
                  {{ $t('editionCommande.renouvellement.yes') }}
                </p>
                <p v-else>{{ $t('editionCommande.renouvellement.no') }}</p>
              </div>
            </b-field>
          </div>
          <div class="column is-3" v-if="devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.labelDateRenouvellementDetail')"
                     custom-class="has-text-weight-light is-italic">
              <p class="has-text-weight-bold has-text-link">
                {{ devisCommande.dateRenouvellement | formatDate }}
              </p>
            </b-field>
          </div>
          <div class="column is-3" v-if="devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.labelDatePreavisDetail')"
                     custom-class="has-text-weight-light is-italic">
              <p class="has-text-weight-bold has-text-link">
                {{ devisCommande.datePreavis | formatDate }}
              </p>
            </b-field>
          </div>
          <div class="column is-3" v-if="devisCommande.etatRenouvellement !== etatEnAttente">
            <b-field :label="$t('editionCommande.renouvellement.etatRenouvellement')"
                     custom-class="has-text-weight-light is-italic">
              <p class="has-text-weight-bold has-text-link">
                {{ $t(getEtat(devisCommande.etatRenouvellement)) }}
              </p>
            </b-field>
          </div>
          <div class="column is-3" v-if="devisCommande.dateDemandeDeRenouvellement">
            <b-field :label="$t('editionCommande.renouvellement.labelDemandeRenouvellementDetail')"
                     custom-class="has-text-weight-light is-italic">
              <p class="has-text-weight-bold has-text-link">
                {{ devisCommande.dateDemandeDeRenouvellement | formatDate }}
              </p>
            </b-field>
          </div>
          <div class="column is-9" v-if="devisCommande.motifNonRenouvellement
          && devisCommande.renouvelable">
            <b-field :label="$t('editionCommande.renouvellement.motifNonRenouvellement')"
                     custom-class="has-text-weight-light is-italic">
              <p class="has-text-weight-bold has-text-link has-text-justified">
                {{ devisCommande.motifNonRenouvellement }}
              </p>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { LISTE_ETAT_RENOUVELLEMENT, ETAT_ENATTENTE } from '@/configuration/devisConf';

export default {
  props: {
    devisCommande: Object,
  },
  data() {
    return {
      etatEnAttente: ETAT_ENATTENTE,
    };
  },
  methods: {
    getEtat(etatCommande) {
      return (LISTE_ETAT_RENOUVELLEMENT.find((etatRenouvellement) => {
        return etatRenouvellement.code === etatCommande;
      })).libelle;
    },
  },
};
</script>

<style scoped>

</style>
